import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { Url, formatTimestamp, security_key } from "../../Services/Api";
import "../../Pages/ECommerce/ECommerce.css";
import "../../Pages/Page.css";
import DataTable from "react-data-table-component";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";

const InsightsHistory = ({ setShowMessage, setToastMessage, setError }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRows, setSelectedRows] = useState([]);
    const rowsPerPage = 7;

    const fetchTableData = async () => {
        setLoading(true);
        setError(null);
        setTimeout(async () => {
            try {
                const token = sessionStorage.getItem('authToken');
                const headers = {
                    Authorization: `Bearer ${token}`,
                    'x-api-key': security_key
                };

                const response = await axios.get(`${Url}/api/v1/performance/web-performance/get`, { headers: headers });
                const getPerformanceHist = response.data.data || [];
                setData(getPerformanceHist);
                setToastMessage("Website Performance data have been fetched successfully!");
                setShowMessage(true);
                console.log(getPerformanceHist);
            } catch (error) {
                const errMsg = error?.response?.data?.message || error.message;
                setError(errMsg);
                setToastMessage(`Failed to fetch Website Performance data: ${errMsg}`);
                setShowMessage(true);
            } finally {
                setLoading(false);
            }
        }, 2000);
    };

    useEffect(() => {
        fetchTableData();
    }, []);

    const handleView = (row) => {
        console.log("View clicked for:", row);
    };

    const handleDownload = async (row) => {
        if (!row._id || !row.resume_url) {
            console.error("Invalid ID or Resume URL");
            return;
        }
        try {
            const response = await axios.get(`https://jfapi.jasonsfurnitureoutlet.com${row.resume_url}`, {
                responseType: "blob",
            });
            console.log("Resume:", response);
            const blob = new Blob([response.data], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `${row.firstName}_${row.lastName}_Resume.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };

    const customStyles = {
        headCells: {
            style: {
                height: "52px",
                background: "transparent",
                opacity: "1",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-medium)",
                fontSize: "var(--font-size-medium)",
                overflow: "wrap",
                textOverflow: "ellipsis",
                whiteSpace: "normal",
            },
        },
        cells: {
            style: {
                height: "66px",
                justifyContent: "center",
                textAlign: "center",
                background: "transparent",
                borderTop: "var(--standered-border)",
                borderRight: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-regular)",
                fontSize: "var(--font-size-small)",
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflow: "wrap",
                textOverflow: "ellipsis",
            },
        },
    };

    const columns = [
        {
            name: "Date",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (
                    `${formatTimestamp(row.createdAt)}`
                ),
            width: "20%",
        },
        {
            name: "Device",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (
                    row.device
                ),
            width: "15%",
        },
        {
            name: "Url",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (
                    row.url
                ),
            width: "50%",
        },
        {
            name: "Score",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (
                    <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        {row.score >= 0 && row.score <= 49 && (
                            <span
                                style={{
                                    width: "10px",
                                    height: "10px",
                                    backgroundColor: "#C61B1A",
                                    borderRadius: "50%",
                                    display: "inline-block",
                                }}
                            ></span>
                        )}
                        {row.score >= 50 && row.score <= 89 && (
                            <span
                                style={{
                                    width: "10px",
                                    height: "10px",
                                    backgroundColor: "#FFC750",
                                    borderRadius: "50%",
                                    display: "inline-block",
                                }}
                            ></span>
                        )}
                        {row.score >= 90 && row.score <= 100 && (
                            <span
                                style={{
                                    width: "10px",
                                    height: "10px",
                                    backgroundColor: "#6BCF1E",
                                    borderRadius: "50%",
                                    display: "inline-block",
                                }}
                            ></span>
                        )}
                        {"  "}{row.score}
                    </span>
                ),
            width: "15%",
        }
    ];

    const handleSelectAll = (isSelected) => {
        if (isSelected) {
            const allRowIds = data.map((row) => row.uid);
            setSelectedRows(allRowIds);
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (rowId) => {
        setSelectedRows((prevSelected) => {
            if (prevSelected.includes(rowId)) {
                return prevSelected.filter((id) => id !== rowId);
            } else {
                return [...prevSelected, rowId];
            }
        });
    };

    const totalPages = Math.ceil(data.length / rowsPerPage);

    const paginatedData = data.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const placeholderRows = Array(7).fill({ uid: "", name: "", image: "" });

    const displayedData = loading ? placeholderRows : paginatedData;

    return (
        <div className="insightTableComponent">

            <div className="Main-Container-Table">

                <div className="Main-Container-insight-table">
                    <div className="insight-table-Data">
                        <div>
                            <DataTable
                                columns={columns}
                                data={displayedData}
                                customStyles={customStyles}
                            />
                            <Pagination
                                activePageIndex={currentPage}
                                totalPages={totalPages}
                                onPrevPage={handlePrevPage}
                                onNextPage={handleNextPage}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default InsightsHistory;